const WELCOME_SEEN_KEY = 'linkd-welcome-first-order-seen';

class LinkdWelcomePopup extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    if (!this.dialog || typeof this.dialog.showModal !== 'function' || window.Shopify?.designMode) return;
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.querySelectorAll('[data-welcome-close]').forEach((button) => button.addEventListener('click', () => this.dialog.close(), options));
    this.dialog.addEventListener('close', () => this.onClose(), options);
    this.dialog.addEventListener('pointerdown', (event) => { this.backdropPress = this.isBackdrop(event); }, options);
    this.dialog.addEventListener('click', (event) => {
      if (this.backdropPress && this.isBackdrop(event)) this.dialog.close();
      this.backdropPress = false;
    }, options);
    window.addEventListener('pagehide', () => {
      window.clearTimeout(this.timer);
      if (this.dialog.open) this.dialog.close();
    }, options);
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) this.schedule();
    }, options);
    if (document.readyState === 'complete') this.schedule();
    else window.addEventListener('load', () => this.schedule(), { ...options, once: true });
  }

  disconnectedCallback() {
    window.clearTimeout(this.timer);
    this.controller?.abort();
    if (this.dialog?.open) this.dialog.close();
    document.documentElement.classList.remove('ld-welcome-open');
  }

  hasSeen() {
    if (this.seen) return true;
    for (const name of ['localStorage', 'sessionStorage']) {
      try {
        if (window[name].getItem(WELCOME_SEEN_KEY)) return true;
      } catch {}
    }
    return false;
  }

  rememberVisit() {
    this.seen = true;
    for (const name of ['localStorage', 'sessionStorage']) {
      try {
        window[name].setItem(WELCOME_SEEN_KEY, '1');
        return;
      } catch {}
    }
  }

  schedule() {
    window.clearTimeout(this.timer);
    if (this.hasSeen()) return;
    const delay = Math.max(0, Math.min(10000, Number(this.dataset.delay) || 1200));
    this.timer = window.setTimeout(() => this.openWhenReady(), delay);
  }

  isBusy() {
    if (document.hidden || document.querySelector('#LinkdPreloader[data-active], dialog[open], details[scroll-lock][open]')) return true;
    if (document.documentElement.hasAttribute('scroll-lock') || document.body.style.position === 'fixed') return true;
    const overlays = document.querySelectorAll('[aria-modal="true"], [role="dialog"]');
    return [...overlays].some((overlay) => overlay !== this.dialog && overlay.getClientRects().length && getComputedStyle(overlay).visibility !== 'hidden');
  }

  openWhenReady() {
    if (!this.isConnected || this.hasSeen()) return;
    if (this.isBusy()) {
      this.timer = window.setTimeout(() => this.openWhenReady(), 500);
      return;
    }
    this.previousFocus = document.activeElement;
    this.dialog.showModal();
    this.rememberVisit();
    document.documentElement.classList.add('ld-welcome-open');
    document.dispatchEvent(new Event('linkd:welcome-toggle'));
  }

  isBackdrop(event) {
    if (event.target !== this.dialog) return false;
    const box = this.dialog.getBoundingClientRect();
    return event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom;
  }

  onClose() {
    document.documentElement.classList.remove('ld-welcome-open');
    document.dispatchEvent(new Event('linkd:welcome-toggle'));
    if (this.previousFocus instanceof HTMLElement && this.previousFocus.isConnected && this.previousFocus !== document.body && this.previousFocus !== document.documentElement) this.previousFocus.focus({ preventScroll: true });
  }
}

if (!customElements.get('linkd-welcome-popup')) customElements.define('linkd-welcome-popup', LinkdWelcomePopup);
